{
  "labels": {
    "textSingleLine": "Texte - Ligne unique",
    "textMultipleLines": "Texte - Lignes multiples",
    "date": "Date",
    "trueFalse": "Vrai/Faux",
    "singleDocument": "Document unique",
    "multiDocument": "Documents multiples",
    "number": "Nombre",
    "eMail": "Courriel",
    "phone": "Téléphone",
    "dropDownSingleSelectList": "Liste déroulante à sélection unique",
    "dropDownMultiSelectList": "Liste déroulante à sélection multiple",
    "comboBox": "Boîte combinée",
    "timestamp": "Horodatage",
    "featureLink": "Lien de fonctionnalité"
  },
  "descriptions": {
    "openTextFieldSingleLine": "Champ de texte ouvert, une ligne",
    "openTextFieldMultipleLines": "Champ de texte ouvert, plusieurs lignes",
    "formatMmDdYyyy": "Format MM/JJ/AAAA",
    "toggleButton": "Bouton à bascule",
    "singleFileUploadField": "Champ de téléchargement de fichier unique",
    "multipleFileUploadField": "Champ de téléchargement de plusieurs fichiers",
    "numericInputField": "Champ de saisie numérique",
    "emailAddressInputField": "Champ de saisie d'adresse courriel",
    "format1XxxXxxXxxx": "Format +1(XXX) XXX-XXXX",
    "selectOneOptionFromAList": "Sélectionner une option dans la liste",
    "selectMultipleOptionsFromAList": "Sélectionner plusieurs options dans la liste",
    "singleOptionDropDownListOpenTextField": "Liste déroulante à option unique + champ de texte ouvert",
    "dateAndTimeFields": "Champs de date et d’heure",
    "linkToTheFormFeatures": "Lien vers les fonctionnalités du formulaire"
  }
}
